import { gql, useQuery } from '@apollo/client'
import { ProductCategory } from '@@partner:types:app'

export interface ProductAvailableCategories {
  categories: ProductCategory[]
}

export interface ProductAvailableCategoriesVariables {
  name: string
}

export const GQL_QUERY_PRODUCT_AVAILABLE_CATEGORIES = gql`
  query ($name: String!) {
    categories: productAvailableCategories(name: $name) {
      id
      name
      parent_id
    }
  }
`

export const useFetchProductAvailableCategories = (
  variables?: ProductAvailableCategoriesVariables
) => {
  return useQuery<
    ProductAvailableCategories,
    ProductAvailableCategoriesVariables
  >(GQL_QUERY_PRODUCT_AVAILABLE_CATEGORIES, {
    variables,
    skip: (!!variables?.name && variables?.name.length < 1)
  })
}
